import * as React from 'react';

import dynamic from 'next/dynamic';

import { CircularProgress } from '@mui/material';

import { CommonStyles } from '@kamernet/styles/CommonStyles';

import { SideFiltersButton as BaseSideFiltersButton } from '@kamernet/modules/Search/components/SideFilters';

import { ListingsSearchContext } from '../../ListingsSearchContext';

const SideFiltersFormDynamic = dynamic(
  () =>
    import('./SideFiltersForm').then(({ SideFiltersForm }) => SideFiltersForm),
  {
    ssr: false,
    loading: () => <CircularProgress className={CommonStyles.margin_auto} />,
  },
);

export const SideFiltersButton = () => {
  const { sideFiltersCount, toggleSideFiltersForm, isSideFiltersFormOpen } =
    ListingsSearchContext.useContext();

  return (
    <BaseSideFiltersButton
      sideFiltersCount={sideFiltersCount}
      toggleSideFiltersForm={toggleSideFiltersForm}
      isSideFiltersFormOpen={isSideFiltersFormOpen}
      form={<SideFiltersFormDynamic />}
    />
  );
};
